/* eslint-disable import/prefer-default-export */
import { exposeEventToPartner } from './events';

export const handleAutoScroll = (
  incomingWidgetHeight,
  iFrameId,
  requiredWidgetHeight,
  minimumWidgetHeight,
  maximumWidgetHeight,
  currentPage,
  widgetResizeDuration
) => {
  /* This function examines before every upcoming widgetHeight change, whether
   * both the current height and the new required height are below the minimum
   * widget height. If yes, there will be no change on the UI and this function
   * will kick off auto scroll immediately. If not, this function returns
   * without further ado. The autoScroll functionality will then get triggered
   * after the widget height resize, by different logic at another place in code.
   */
  const currentWidgetHeight = requiredWidgetHeight;
  const wasAutoScrollInvokedByComponent =
    window.__private__?.pageAutoScrollInvocationTracker &&
    !!window.__private__?.pageAutoScrollInvocationTracker[currentPage];

  if (
    (!wasAutoScrollInvokedByComponent &&
      typeof currentWidgetHeight === 'number' &&
      typeof maximumWidgetHeight === 'number' &&
      typeof minimumWidgetHeight === 'number' &&
      typeof incomingWidgetHeight === 'number' &&
      currentWidgetHeight <= minimumWidgetHeight &&
      incomingWidgetHeight <= minimumWidgetHeight) ||
    (currentWidgetHeight >= maximumWidgetHeight &&
      incomingWidgetHeight >= maximumWidgetHeight)
  ) {
    const eventObject = {
      iFrameId,
    };
    if (
      !window.__private__ ||
      typeof window.__private__ !== 'object' ||
      Array.isArray(window.__private__)
    ) {
      window.__private__ = {};
    }
    window.__private__.pageAutoScrollInvocationTracker = {}; // tracks the latest page to have had autoScroll invoked against it
    window.__private__.pageAutoScrollInvocationTracker[currentPage] = true;
    // In the <AutoScrollWidgetRepositioning/> component, auto scroll is currently set to occur after the enter phase of a page transition completes. This timeout keeps this auto scroll invocation behaviour consistent with <AutoScrollWidgetRepositioning/> because page transitions take as long as widgetResizeDuration.
    setTimeout(
      () =>
        exposeEventToPartner({
          eventType: 'invokeAutoScroll',
          eventObject,
        }),
      widgetResizeDuration
    );
  }
};
